
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/patreon",
      function () {
        return require("private-next-pages/patreon.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/patreon"])
      });
    }
  